import React, { useEffect, useState } from 'react';
import { useGetAdvertisingQuery } from '../redux/services/blog/AdvertisingAPI';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { RiCloseFill } from 'react-icons/ri';

function Advertising() {
  const { data: ads, isError, isLoading } = useGetAdvertisingQuery();
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!ads?.length) return;
    const timer = setTimeout(() => {
      setCurrentAdIndex((prevIndex) => (prevIndex + 1) % ads.length);
    }, 5000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ads?.length]);

  if (isLoading) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  if (isError || !ads?.length || !show) return null;

  const ad = ads[currentAdIndex];
  const image = ad?.main_image?.startsWith('http') ? ad.main_image : `https://gotrip-okdz.onrender.com${ad.main_image}`;

  return (
    <div className="fixed inset-x-0 bottom-4 z-40 px-4 sm:bottom-6">
      <div className="section-shell">
        <div className="overflow-hidden rounded-[2rem] border border-white/70 bg-white/95 p-3 shadow-soft backdrop-blur">
          <div className="grid gap-4 sm:grid-cols-[9rem_1fr_auto] sm:items-center">
            <img src={image} alt={ad.title} className="h-28 w-full rounded-2xl object-cover sm:h-24" />
            <div className="min-w-0">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-gotrip-700">GoTrip update</p>
              <h2 className="mt-1 truncate text-lg font-black tracking-tight text-ink">{ad.title}</h2>
              <p className="mt-1 max-h-12 overflow-hidden text-sm leading-6 text-muted">{ad.description || 'Explore curated stays and dining experiences with a smoother booking flow.'}</p>
            </div>
            <button type="button" onClick={() => setShow(false)} className="self-start rounded-full p-2 text-muted transition hover:bg-slate-100 hover:text-ink" aria-label="Close announcement">
              <RiCloseFill className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Advertising;
